/**
 * Converte un valore in Number in modo sicuro.
 * Gestisce:
 * - number
 * - stringhe "1234,56", "1.234,56", "1,234.56"
 * - null / undefined / ""
 * Ritorna:
 * - Number
 * - null se non convertibile
 */
export function toNumberSafe(v) {

    if (v === null || v === undefined || v === "") return null;

    // già number
    if (typeof v === "number") return v;

    // stringhe tipo "1.234,56" o "1234,56" o "1,234.56"
    if (typeof v === "string") {
      let s = v.trim();

      // se contiene sia . che , assumo che l'ultimo separatore sia il decimale
      const lastDot = s.lastIndexOf(".");
      const lastComma = s.lastIndexOf(",");

      if (lastDot > -1 && lastComma > -1) {
        const decSep = lastDot > lastComma ? "." : ",";
        const thouSep = decSep === "." ? "," : ".";
        s = s.split(thouSep).join("");
        s = s.replace(decSep, ".");
      } else {
        // solo virgola -> virgola decimale
        if (s.includes(",")) s = s.replace(/\./g, "").replace(",", ".");
        // solo punto -> punto decimale (ok), tolgo eventuali separatori migliaia con spazio
        s = s.replace(/ /g, "");
      }

      const n = Number(s);
      return Number.isFinite(n) ? n : null;
    }

    // altro (Date, boolean, ecc.)
    return null;
}